import { Rating } from '@mui/material'
import React from 'react'

const RatingView = ({value} : any) => {
  return (
    <div className='flex items-center gap-2'>
        Rating:
        <Rating
            value={value}   // static value for display
            readOnly    // make it read-only
            max={5}     // 5 stars
        />
    </div>
  )
}

export default RatingView